// import React, { useState, useEffect } from "react";
// import { Plus, Search, Trash2, Edit2, Printer } from "lucide-react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';



// const SalesTable = ({ toggleSidebar }) => {
//   const [salesData, setSalesData] = useState([]);
//   const [deleteShowModal, setDeleteShowModal] = useState(false);
//   const [deleteId, setDeleteId] = useState("");
//   const [deleteName, setDeleteName] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Fetch sales data
//   useEffect(() => {
//     fetchSales();
    
//   }, []);

//   const fetchSales = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const response = await axios.get(`${ApiUrl}/sales_data.php`);
//       if (response.data && response.data.data) {
//         setSalesData(response.data.data);
//       } else {
//         setSalesData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching sales:", error);
//       // setError("Failed to load sales data or no data");
//       // toast.error("Failed to fetch");
//       setSalesData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePrint = (id) => {
//     navigate(`/invoice/${id}`);
//   };

//   // CORRECTED: Handle delete function - now sends 'id' parameter to match backend
//   const handleDelete = async () => {
//     if (!deleteId) {
//       setError("No sales ID selected for deletion");
//       return;
//     }

//     try {
//       setIsLoading(true);
//       setError(null);
//       // setSuccessMessage("");

//       // Send Sales_ID as query parameter
//       const response = await axios.delete(`${ApiUrl}/sales_data.php?id=${deleteId}`);
//       toast.success(`Sales ${deleteName} deleted successfully!`);
//       if (response.data && response.data.status) {
//         console.log("Sale deleted successfully:", response.data);
//         // setSuccessMessage(`Sales record ${deleteId} deleted successfully`);
//         setDeleteShowModal(false);
//         setDeleteId("");
//         setDeleteName("");
//         // Refresh the data after successful deletion
//         await fetchSales();

//         // Clear success message after 3 seconds
//         // setTimeout(() => {
//         //   setSuccessMessage("");
//         // }, 3000);
//       } else {
//         throw new Error(response.data.message || "Failed to delete sale");
//       }
//     } catch (error) {
//       console.error("Error deleting sale:", error);
//       setError(error.response?.data?.message || error.message || "Failed to delete sale");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // CORRECTED: Use Sales_ID for deletion (this should match the Sales_ID column in your database)
//   const openDeleteModal = (salesId, displayName) => {
//     setDeleteShowModal(true);
//     setDeleteId(salesId); // Use Sales_ID for deletion
//     setDeleteName(displayName); // Use Sales_ID for display
//   };

//   const openEditModal = (salesId, data) => {
//     navigate(`/updateSales/${salesId}`, { state: { editData: data } });
//     toggleSidebar()
//   };





//   const filteredBranches = salesData.filter((branch) =>
//     Object.values(branch)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredBranches.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentBranches = filteredBranches.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   // Payment status badge
//   const getPaymentStatusBadge = (status) => {
//     const normalized = status?.toLowerCase();
//     const statusMap = {
//       paid: "bg-success bg-opacity-10 text-success",
//       partial: "bg-warning bg-opacity-10 text-warning",
//       unpaid: "bg-danger bg-opacity-10 text-danger",
//     };

//     const iconMap = {
//       paid: "✓",
//       unpaid: "×",
//       partial: "⚬",
//     };

//     return (
//       <span
//         className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${statusMap[normalized] || "bg-secondary bg-opacity-10 text-secondary"
//           }`}
//       >
//         {iconMap[normalized] || "?"} {status}
//       </span>
//     );
//   };




//   const navigatesales = () => {
//     toggleSidebar();
//     navigate("/Navigatesales")
//   }






//   return (
//     <div className="bg-white font-sans">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
//       {/* Header */}
//       <div className="p-3 p-md-4 bg-white">
//         <div className="d-flex justify-content-between align-items-center">
//           <h2 className="m-0 fs-5 fw-semibold text-dark">Sales</h2>
//           <button
//             onClick={navigatesales}
//             className="btn btn-danger d-flex align-items-center gap-2"
//             disabled={isLoading}
//           >
//             <Plus size={18} />
//             Add Sale
//           </button>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="alert alert-danger mx-3 mx-md-4" role="alert">
//           {error}
//         </div>
//       )}

//       {/* Main Card Container */}
//       <div className="card mx-3 mx-md-4 border mb-5" >
//         {/* Controls Row */}
//         <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
//           {/* Show All Dropdown */}
//           <div
//             className="d-flex align-items-center gap-2"
//             style={{ height: "36px", width: "120px" }}
//           >
//             <div
//               className="d-flex align-items-center justify-content-center"
//               style={{ height: "28px", width: "14px" }}
//             >
//               <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
//                 <rect x="1" y="1" width="3" height="3" fill="#666" />
//                 <rect x="1" y="5" width="3" height="3" fill="#666" />
//                 <rect x="1" y="9" width="3" height="2" fill="#666" />
//                 <rect x="5" y="1" width="6" height="1" fill="#666" />
//                 <rect x="5" y="3" width="6" height="1" fill="#666" />
//                 <rect x="5" y="5" width="6" height="1" fill="#666" />
//                 <rect x="5" y="7" width="6" height="1" fill="#666" />
//                 <rect x="5" y="9" width="6" height="1" fill="#666" />
//               </svg>
//             </div>
//             <select
//               className="border-0 bg-transparent text-dark form-select form-select-sm"
//               style={{
//                 boxShadow: "none",
//                 outline: "none",
//                 lineHeight: "1.1",
//                 height: "28px",
//                 cursor: "pointer",
//                 width: "80px",
//                 paddingTop: "0",
//                 paddingBottom: "0",
//               }}
//               value={itemsPerPage}
//               onChange={(e) => {
//                 setItemsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">Show 5</option>
//               <option value="10">Show 10</option>
//               <option value="25">Show 25</option>
//               <option value={filteredBranches.length}>Show All</option>
//             </select>
//           </div>

//           {/* Search */}
//           <div className="position-relative" style={{ width: "280px" }}>
//             <input
//               type="text"
//               placeholder="Search"
//               className="w-100 ps-3 pe-5 py-2 border rounded form-control"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <Search
//               size={18}
//               className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
//               style={{ pointerEvents: "none" }}
//             />
//           </div>
//         </div>

//         {/* Table Container */}
//         <div className="card-body p-0">
//           {/* Table */}
//           <div className="table-responsive">
//             <table className="table table-hover mb-0 text-center">
//               <thead>
//                 <tr>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     S.No
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Invoice No
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Date
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Name
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Total Items
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Net Total
//                   </th>
                

//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Paid
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className="p-3 fw-semibold small"
//                   >
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentBranches.length > 0 ? (
//                   currentBranches.map((sale, index) => (
//                     <tr key={index} style={{ fontSize: "14px" }}>
//                       <td>{startIndex + index + 1}</td>
//                       <td>{sale.Sales_ID}</td>
//                       <td>{sale.Purchase_Date}</td>
//                       <td>{sale.name}</td>
//                       <td>{sale.Sales_Items?.length}</td>
//                       <td>{sale.Net_total}</td>
                   


//                       <td>₹{Number(sale.Paid_Amount).toLocaleString()}</td>

//                       <td className="small">
//                         <div className="d-flex justify-content-center gap-1">
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() =>
//                               openDeleteModal(sale.Sales_ID, sale.Sales_ID)
//                             }
//                             disabled={isLoading}
//                             title="Delete"
//                           >
//                             <Trash2 size={16} />
//                           </button>
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() => openEditModal(sale.Sales_ID, sale)}
//                             disabled={isLoading}
//                             title="Edit"
//                           >
//                             <Edit2 size={16} />
//                           </button>
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() => handlePrint(sale.id)}
//                             disabled={isLoading}
//                             title="Print Invoice"
//                           >
//                             <Printer size={16} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={8} className="text-center p-5">
//                       {isLoading ? "Loading..." : "No data available."}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {itemsPerPage < filteredBranches.length && (
//             <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1
//                   ? "bg-light text-muted"
//                   : "bg-white text-dark"
//                   }`}
//               >
//                 <FaChevronLeft size={14} />
//                 <span className="ms-1 d-none d-md-inline">Previous</span>
//               </button>

//               <div className="d-flex gap-1">
//                 {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                   let pageNum;
//                   if (totalPages <= 5) {
//                     pageNum = i + 1;
//                   } else if (currentPage <= 3) {
//                     pageNum = i + 1;
//                   } else if (currentPage >= totalPages - 2) {
//                     pageNum = totalPages - 4 + i;
//                   } else {
//                     pageNum = currentPage - 2 + i;
//                   }

//                   return (
//                     <button
//                       key={pageNum}
//                       onClick={() => setCurrentPage(pageNum)}
//                       className={`btn btn-sm ${pageNum === currentPage
//                         ? "bg-danger bg-opacity-10 text-danger"
//                         : "bg-white text-dark"
//                         }`}
//                       style={{ width: "32px", height: "32px" }}
//                     >
//                       {pageNum}
//                     </button>
//                   );
//                 })}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <span className="px-2 py-1">...</span>
//                 )}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <button
//                     onClick={() => setCurrentPage(totalPages)}
//                     className={`btn btn-sm ${totalPages === currentPage
//                       ? "bg-danger bg-opacity-10 text-danger"
//                       : "bg-white text-dark"
//                       }`}
//                     style={{ width: "32px", height: "32px" }}
//                   >
//                     {totalPages}
//                   </button>
//                 )}
//               </div>

//               <button
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages
//                   ? "bg-light text-muted"
//                   : "bg-white text-dark"
//                   }`}
//               >
//                 <span className="ms-1 d-none d-md-inline">Next</span>
//                 <FaChevronRight size={14} />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModal ? "show" : ""}`}
//         style={{
//           display: deleteShowModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-modal="true"
//         onClick={(e) => {
//           if (e.target === e.currentTarget) {
//             setDeleteShowModal(false);
//           }
//         }}
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
//                   style={{ width: "80px", height: "80px" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>
//               <h4 className="modal-title mb-3">Are you sure?</h4>
//               <h6 className="mb-4">
//                 Do you really want to delete sale record{" "}
//                 <span className="text-primary fw-bold">({deleteName})</span>?
//               </h6>
//               <div className="d-flex gap-2">
//                 <button
//                   type="button"
//                   className="btn btn-secondary flex-grow-1"
//                   onClick={() => setDeleteShowModal(false)}
//                   disabled={isLoading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger flex-grow-1"
//                   onClick={handleDelete}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesTable;


import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2, Printer } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SalesTable = ({ toggleSidebar }) => {
  const [salesData, setSalesData] = useState([]);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [privileges, setPrivileges] = useState(null);
  const navigate = useNavigate();

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  // Fetch sales data
  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axios.get(`${ApiUrl}/sales_data.php`);
      if (response.data && response.data.data) {
        setSalesData(response.data.data);
      } else {
        setSalesData([]);
      }
    } catch (error) {
      console.error("Error fetching sales:", error);
      setSalesData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = (Sales_ID) => {
    navigate(`/invoice_sales/${Sales_ID}`);
  };

  // Handle delete function
  const handleDelete = async () => {
    if (!deleteId) {
      setError("No sales ID selected for deletion");
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      // Send Sales_ID as query parameter
      const response = await axios.delete(`${ApiUrl}/sales_data.php?id=${deleteId}`);
      toast.success(`Sales ${deleteName} deleted successfully!`);
      if (response.data && response.data.status) {
        console.log("Sale deleted successfully:", response.data);
        setDeleteShowModal(false);
        setDeleteId("");
        setDeleteName("");
        // Refresh the data after successful deletion
        await fetchSales();
      } else {
        throw new Error(response.data.message || "Failed to delete sale");
      }
    } catch (error) {
      console.error("Error deleting sale:", error);
      setError(error.response?.data?.message || error.message || "Failed to delete sale");
    } finally {
      setIsLoading(false);
    }
  };

  const openDeleteModal = (salesId, displayName) => {
    setDeleteShowModal(true);
    setDeleteId(salesId); // Use Sales_ID for deletion
    setDeleteName(displayName); // Use Sales_ID for display
  };

  const openEditModal = (salesId, data) => {
    navigate(`/updateSales/${salesId}`, { state: { editData: data } });
    toggleSidebar();
  };

  const filteredBranches = salesData.filter((branch) =>
    Object.values(branch)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredBranches.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentBranches = filteredBranches.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Payment status badge (unused in current table, but kept for potential future use)
  const getPaymentStatusBadge = (status) => {
    const normalized = status?.toLowerCase();
    const statusMap = {
      paid: "bg-success bg-opacity-10 text-success",
      partial: "bg-warning bg-opacity-10 text-warning",
      unpaid: "bg-danger bg-opacity-10 text-danger",
    };

    const iconMap = {
      paid: "✓",
      unpaid: "×",
      partial: "⚬",
    };

    return (
      <span
        className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${statusMap[normalized] || "bg-secondary bg-opacity-10 text-secondary"
          }`}
      >
        {iconMap[normalized] || "?"} {status}
      </span>
    );
  };

  const navigatesales = () => {
    toggleSidebar();
    navigate("/Navigatesales");
  };

  return (
    <div className="bg-white font-sans">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
      {/* Header */}
      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="m-0 fs-5 fw-semibold text-dark">Sales</h2>
          <button
            onClick={navigatesales}
            className="btn btn-danger d-flex align-items-center gap-2"
            disabled={isLoading}
          >
            <Plus size={18} />
            Add Sale
          </button>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="alert alert-danger mx-3 mx-md-4" role="alert">
          {error}
        </div>
      )}

      {/* Main Card Container */}
      <div className="card mx-3 mx-md-4 border mb-5">
        {/* Controls Row */}
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          {/* Show All Dropdown */}
          <div
            className="d-flex align-items-center gap-2"
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredBranches.length}>Show All</option>
            </select>
          </div>

          {/* Search */}
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        {/* Table Container */}
        <div className="card-body p-0">
          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover mb-0 text-center">
              <thead>
                <tr>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    S.No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Invoice No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Date
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Name
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Total Items
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Net Total
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Paid
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentBranches.length > 0 ? (
                  currentBranches.map((sale, index) => (
                    <tr key={sale.Sales_ID} style={{ fontSize: "14px" }}>
                      <td>{startIndex + index + 1}</td>
                      <td>{sale.Sales_ID}</td>
                      <td>{sale.Purchase_Date}</td>
                      <td>{sale.name}</td>
                      <td>{sale.Sales_Items?.length}</td>
                      <td>{sale.Net_total}</td>
                      <td>₹{Number(sale.Paid_Amount).toLocaleString()}</td>
                      <td className="small">
                        <div className="d-flex justify-content-center gap-1">
                          {privileges === "Admin" && (
                            <button
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              onClick={() =>
                                openDeleteModal(sale.Sales_ID, sale.Sales_ID)
                              }
                              disabled={isLoading}
                              title="Delete"
                            >
                              <Trash2 size={16} />
                            </button>
                          )}
                          {(privileges === "Admin" || privileges === "Manager") && (
                            <button
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              onClick={() => openEditModal(sale.Sales_ID, sale)}
                              disabled={isLoading}
                              title="Edit"
                            >
                              <Edit2 size={16} />
                            </button>
                          )}
                          <button
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                            onClick={() => handlePrint(sale.Sales_ID)}
                            disabled={isLoading}
                            title="Print Invoice"
                          >
                            <Printer size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center p-5">
                      {isLoading ? "Loading..." : "No data available."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {itemsPerPage < filteredBranches.length && (
            <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1
                  ? "bg-light text-muted"
                  : "bg-white text-dark"
                  }`}
              >
                <FaChevronLeft size={14} />
                <span className="ms-1 d-none d-md-inline">Previous</span>
              </button>

              <div className="d-flex gap-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`btn btn-sm ${pageNum === currentPage
                        ? "bg-danger bg-opacity-10 text-danger"
                        : "bg-white text-dark"
                        }`}
                      style={{ width: "32px", height: "32px" }}
                    >
                      {pageNum}
                    </button>
                  );
                })}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <span className="px-2 py-1">...</span>
                )}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className={`btn btn-sm ${totalPages === currentPage
                      ? "bg-danger bg-opacity-10 text-danger"
                      : "bg-white text-dark"
                      }`}
                    style={{ width: "32px", height: "32px" }}
                  >
                    {totalPages}
                  </button>
                )}
              </div>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages
                  ? "bg-light text-muted"
                  : "bg-white text-dark"
                  }`}
              >
                <span className="ms-1 d-none d-md-inline">Next</span>
                <FaChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModal ? "show" : ""}`}
        style={{
          display: deleteShowModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setDeleteShowModal(false);
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3">Are you sure?</h4>
              <h6 className="mb-4">
                Do you really want to delete sale record{" "}
                <span className="text-primary fw-bold">({deleteName})</span>?
              </h6>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary flex-grow-1"
                  onClick={() => setDeleteShowModal(false)}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger flex-grow-1"
                  onClick={handleDelete}
                  disabled={isLoading}
                >
                  {isLoading ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesTable;